// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/design-system/components/forms/Checkbox.jsx

import React, { forwardRef } from "react";
import "./forms.css";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

const Checkbox = forwardRef(function Checkbox(
  { label, description = "", className = "", disabled = false, ...inputProps },
  ref
) {
  return (
    <label
      className={joinClassNames(
        "oasys-check",
        disabled && "oasys-check--disabled",
        className
      )}
    >
      <input
        {...inputProps}
        ref={ref}
        type="checkbox"
        disabled={disabled}
        className="oasys-check__input"
      />
      <span className="oasys-check__box" aria-hidden="true" />
      <span className="oasys-check__content">
        <span className="oasys-check__label">{label}</span>
        {description ? (
          <span className="oasys-check__description">{description}</span>
        ) : null}
      </span>
    </label>
  );
});

export default Checkbox;
